"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const spinner_1 = require("src/redux/selectors/spinner");
const theme_mode_1 = require("src/hooks/theme_mode");
const branding_1 = require("src/context/branding");
const modal_1 = require("src/context/modal");
const spinner_styles_1 = __importDefault(require("./spinner.styles"));
const default_1 = __importDefault(require("./assets/default"));
const portal_1 = __importDefault(require("./assets/portal"));
const b = b_1.default.with('spinner');
const DEFAULT_SPINNER_COLOR = '#5178E2';
const SPINNERS = {
    'default': default_1.default,
    'portal': portal_1.default
};
// eslint-disable-next-line complexity, max-statements
function Spinner() {
    var _a, _b, _c, _d;
    const isDarkTheme = (0, theme_mode_1.useIsDarkMode)();
    const context = (0, modal_1.useModalContext)();
    const isMorda = (context === null || context === void 0 ? void 0 : context.surveyPreset) === 'yandexMorda';
    const { color = DEFAULT_SPINNER_COLOR } = (0, spinner_1.useSpinnerProps)();
    const branding = (0, branding_1.useBrandingContext)() || {};
    const brandingSpinnerColor = isDarkTheme ? ((_b = (_a = branding.darkTheme) === null || _a === void 0 ? void 0 : _a.spinner) === null || _b === void 0 ? void 0 : _b.color) || DEFAULT_SPINNER_COLOR : ((_c = branding.spinner) === null || _c === void 0 ? void 0 : _c.color) || color;
    const brandingView = (_d = branding.spinner) === null || _d === void 0 ? void 0 : _d.view;
    const isValidView = brandingView && brandingView in SPINNERS;
    const spinner = {
        color: isMorda ? 'black' : brandingSpinnerColor,
        // eslint-disable-next-line no-nested-ternary
        view: isMorda ? 'portal' : isValidView ? brandingView : 'default'
    };
    const SpinnerComponent = SPINNERS[spinner.view];
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: spinner_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('circle') }, { children: (0, jsx_runtime_1.jsx)(SpinnerComponent, { color: spinner.color }) }))] })));
}
exports.default = Spinner;
